import { useEffect } from 'react';

const SEO = ({ title, description }) => {
    useEffect(() => {
        // Update title
        document.title = title;

        // Update meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }
        metaDescription.content = description;

        // Cleanup function to reset (optional, but good practice if needed)
        // For a SPA, we usually just let the next page overwrite it.
    }, [title, description]);

    return null;
};

export default SEO;
